export const cacheKeys = {
  getAssertion: 'getAssertion',
  getNextAssertion: 'getNextAssertion',
  getAssertions: 'getAssertions',
  answerAssertions: 'answerAssertions',
  answerAssertionsResults: 'answerAssertionsResults',
  getAssertionImages: 'getAssertionImages',
  getPreviousAssertion: 'getPreviousAssertion',

  getFunFacts: 'getFunFacts',
};
